(function()
{
	// Include the parent class
	var Application = include('springroll.Application');
	var Container = include('PIXI.Container');
	var Debug = include('springroll.Debug', false);
	var DelayedCall = include('springroll.DelayedCall');
	var Floater = include('nature.Floater');
	var Hal = include('nature.Hal');
	var DebugOptions = include('nature.DebugOptions');
	var Powerup = include('nature.enum.Powerup');
	var PowerupManager = include('nature.PowerupManager');
	var RandomList = include('springroll.RandomList');
	var Task = include('nature.enum.Task');
	var ScrollingBackground = include('nature.ScrollingBackground');
	var State = include('springroll.State');
	var Tutorial = include('nature.Tutorial');
	var Tween = include('createjs.Tween');

	var FIVE_HUNDRED_FT = 500;

	var _app;
	var _config;
	var _displayDistance;
	var _levelSegments;
	var _powerupManager;
	var _restartPowerupAfterCountdown;

	// Create a new state for the Game section of the game
	var GameState = function(options)
	{
		State.call(this, new nature.GamePanel(), options);

		_app = Application.instance;
		_config = _app.config;

		/**
		 * how far have we gone (in 'feet')
		 * @type {Number}
		 */
		_displayDistance = 0;

		this.endGameplayPhase = this.endGameplayPhase.bind(this);
		this.handlePauseRestart = this.handlePauseRestart.bind(this);
		this.launch = this.launch.bind(this);
		this.moveOffHal = this.moveOffHal.bind(this);
		this.onCollectPowerup = this.onCollectPowerup.bind(this);
		this.onEnter = this.onEnter.bind(this);
		this.onExit = this.onExit.bind(this);
		this.onHalStart = this.onHalStart.bind(this);
		this.onResumed = this.onResumed.bind(this);
		this.restart = this.restart.bind(this);
		this.startBlowPhase = this.startBlowPhase.bind(this);
		this.startControlCountdown = this.startControlCountdown.bind(this);
		this.startGameplayPhase = this.startGameplayPhase.bind(this);
		this.startPlacingObjects = this.startPlacingObjects.bind(this);
		this.togglePause = this.togglePause.bind(this);
		this.update = this.update.bind(this);

		this.on('loaded', this.onAssetsLoaded);
		this.on('loading', this.onLoading);
		_app.load(app.config.assets.game.floaters, function(results)
		{
			// Pre-instantiate objects
			var floatersDict = _config.floaters;
			for (var type in floatersDict)
			{
				if (_app.floaterPools[type])
				{
					//
				}
				else
				{
					_app.floaterPools[type] = [];
					// Premake at least one of each
					var premake = floatersDict[type].premake || 1;
					for (var i = 0; i < premake; i++)
					{
						var floater = new Floater(floatersDict[type], null, type);
						_app.floaterPools[type].push(floater);
					}
				}
			}
		});

		/**
		 * The list of level segments
		 * @property {springroll.RandomList} levelSegments
		 */
		_levelSegments = null;
	};

	// inherit the prototype chain from State
	var s = State.prototype;
	var p = extend(GameState, State);

	p.onResumed = function()
	{
		this.pauseMedia = false;
		this.pauseTween = false;
	};

	/**
	 * Handle the config loaded event
	 * @param {Object} config The configuration loaded
	 * @param {Array} assets Add assets
	 */
	p.onLoading = function(assets)
	{
		var userData = _app.userData;
		assets.push(
		{
			id: Tutorial.COOKIE_NAME,
			async: function(done)
			{
				userData.read(Tutorial.COOKIE_NAME, done);
			}
		});
	};

	/**
	 * Handler when the assets are finished loading
	 * @method onAssetsLoaded
	 */
	p.onAssetsLoaded = function()
	{
		var panel = this.panel;
		panel.setup(_app.config);
		var difficulty = Number(DebugOptions.difficulty) || 0;

		// Check for new background
		this.scrollingBackground = new ScrollingBackground(_app.config.backgrounds);
		panel.worldScaler.addChildAt(this.scrollingBackground, 0);
		panel.camera.scrollingBackground = this.scrollingBackground;
		this.setLevel(DebugOptions.level || 0);

		/**
		 * The tutorial object
		 * @property {nature.Tutorial} tutorial
		 */
		this.tutorial = new Tutorial(this);

		// If we have completed the tutorial, Disable it
		if (_app.getCache(Tutorial.COOKIE_NAME))
		{
			_app.isTutorial = false;
		}
		if (DebugOptions.tutorial)
		{
			_app.isTutorial = true;
		}


		// Pre-intantiate HAL to keep from studdering when he first enters the scene
		_app.hal = mixin(new pixiflash_lib.HalRunClip(), Hal, panel);
		_app.hal.once('halStart', this.onHalStart);
		// goto the first frame of naturecat
		var firstFrame = _app.skipIntro ? 'breathe' : 'intro';
		panel.natureCat.gotoAndStop(firstFrame);
	};

	p.onHalStart = function()
	{
		if (!this.hasPlayedHalAudio && !_app.voPlayer.playing)
		{
			this.hasPlayedHalAudio = true;
			_app.voPlayer.play('NCat_TryHal');
		}
	};

	/**
	 * @param {int} level
	 */
	p.setLevel = function(level)
	{
		this.currDifficulty = _config.difficulty[level];
		this.currDifficulty.startingDistance = this.panel.hud.distance || 0;
		_levelSegments = new RandomList(_config.levelSegments[level]);

		// For testing, allow us to specify a certain segment (or segments) to play over and over
		if (DebugOptions.segment)
		{
			var arr = [];
			if (DebugOptions.segment.indexOf(',') === -1)
			{
				var n = Number(option);
				arr.push(_config.levelSegments[difficulty][n]);
			}
			else
			{
				var indexes = DebugOptions.segment.split(',');
				for (var i = 0, len = indexes.length; i < len; i++)
				{
					arr.push(_config.levelSegments[difficulty][Number(indexes[i])]);
				}
			}
			_levelSegments = new RandomList(arr);
		}
	};

	/**
	 * When the state is entered play the intro
	 * @method enterDone
	 */
	p.enterDone = function()
	{
		// If the application resumes and the game is paused,
		// re-pause the tweens and the animator
		_app.on('resumed', this.onResumed, -1);

		var panel = this.panel;

		_app.isGameOver = false;
		if (DebugOptions.skipLaunch)
		{
			this.burstObject = panel.breathMeter.getBurstPower(30);
			this.startGameplayPhase();
			this.lockControls(true);
			return;
		}
		else if (
			_app.skipIntro ||
			DebugOptions.tutorial ||
			DebugOptions.skipTut)
		{
			this.startBlowPhase();
			return;
		}
		else if (DebugOptions.testScore)
		{
			// Show score phase
			this.startScorePhase();
			return;
		}

		// Default controls off
		panel.hud.show(false);

		_app.animator.play(panel.natureCat,
		{
			anim: 'intro',
			audio:
			{
				alias: 'NCat_Intro',
				start: 1600
			}
		}, this.startBlowPhase);

		_app.skipIntro = true;
	};

	/******************
		Blow Phase
	*******************/

	p.startBlowPhase = function()
	{
		var sound = _app.sound;
		sound.play('Anemometer',
		{
			loop: true
		});
		sound.play('WindSockBlowing',
		{
			loop: true
		});

		var panel = this.panel;
		panel.setupBlow();
		panel.breathMeter.once('complete', this.launch);
		this.tutorial.startBlowPhase();
	};

	/**
	 * Used in the blow phase, called from the burst meter
	 * @public
	 * @method launch
	 * @param {Object} burstObject Object from the `BreathMeter` contains `bucket` and `power`; `bucket` is currently 0..3
	 * @return {[type]}
	 */
	p.launch = function(burstObject)
	{
		this.tutorial.launch();
		this.burstObject = burstObject;

		// Play a nature cat reaction based on what burst
		// bucket we were placed in, then start gameplay
		_app.sound.stop('NCat_BreatheLoop');
		var natureCat = this.panel.natureCat;
		natureCat.stopAnimation();
		//ensure that events are cleared
		natureCat.off('startBlow', this.startGameplayPhase);
		natureCat.off('animComplete', this.startGameplayPhase);
		this.gameplayStarted = false;
		natureCat.playAnimation(burstObject.bucket.anim);
		natureCat.once('startBlow', this.startGameplayPhase);
		//set up a backup in case the startBlow event gets skipped
		natureCat.once('animComplete', this.startGameplayPhase);
	};

	/************************
		Gameplay Phase
	*************************/

	/**
	 * The gameplay
	 * @method startGameplayPhase
	 */
	p.startGameplayPhase = function()
	{
		if (this.gameplayStarted) return;

		this.gameplayStarted = true;
		var panel = this.panel;
		_app.sound.stop('Anemometer');
		_app.sound.stop('WindSockBlowing');

		this.panel.setupGameplay(this.burstObject.power);

		// Seed container does not exist until after setupGamemplay
		var seedContainer = this.panel.seedContainer;
		seedContainer.on('startPlacingObjects', this.startPlacingObjects);
		seedContainer.on('startControlCountdown', this.startControlCountdown);
		seedContainer.start(this.burstObject.power);

		_app.on('update', this.update);

		if (_app.isTutorial)
		{
			this.tutorial.startGameplayPhase();
			return;
		}

		seedContainer.on('collectPowerup', this.onCollectPowerup);
		seedContainer.on('moveOffHal', this.moveOffHal);
		seedContainer.on('lose', this.endGameplayPhase);

		seedContainer.startInvulnerability();

		panel.hud.show();
		panel.hud.pauseButton.on('buttonPress', this.togglePause);
	};

	/**
	 * End the game play session
	 * @method endGameplayPhase
	 */
	p.endGameplayPhase = function()
	{
		var panel = this.panel;
		var seedContainer = panel.seedContainer;
		var hud = panel.hud;

		_app.isGameOver = true;
		_app.voPlayer.stop();

		// Ending via an event from seed container -
		// player crashed into the ground
		seedContainer.off('moveOffHal', this.moveOffHal);
		seedContainer.off('lose', this.endGameplayPhase);
		seedContainer.off('startControlCountdown', this.startControlCountdown);
		seedContainer.off('startPlacingObjects', this.startPlacingObjects);

		hud.pauseButton.off('buttonPress', this.togglePause);
		hud.show(false);

		// Show score phase
		this.startScorePhase();
	};

	p.moveOffHal = function()
	{
		_restartPowerupAfterCountdown = true;
		this.startControlCountdown();
	};

	/**
	 * @param {boolean} skipCountdown
	 */
	p.startControlCountdown = function(skipCountdown)
	{
		var onGo = function()
		{
			this.lockControls(false);
			if (_app.isTutorial && this.tutorial.getTask() == Task.Fly)
			{
				this.tutorial.nextTask(Task.Fly);
			}
			if (_restartPowerupAfterCountdown)
			{
				_powerupManager.startCountdown();
			}
		}.bind(this);

		if (skipCountdown)
		{
			onGo();
			return;
		}

		this.lockControls(true);
		this.controlCountdown = mixin(
			new pixiflash_lib.ControlIcon(),
			nature.ControlCountdown);
		this.panel.uiContainer.addChild(this.controlCountdown);

		var voTimePlusExtra = 6000;
		// Avoid overlapping countdown with Nature Cat's boost vo
		if (_app.voPlayer.playing)
		{
			_app.voPlayer._callback = function()
			{
				// See startInvulnerability comment below...
				this.panel.seedContainer.startInvulnerability(voTimePlusExtra);
				this.controlCountdown.start(onGo);
			}.bind(this);
		}
		else
		{
			// Enough invulnerable time for the coutndown AND a little extra since user doesn't actually have control enough to avoid obstacles coming right at them on release
			if (!_app.isTutorial && this.panel.seedContainer)
			{
				this.panel.seedContainer.startInvulnerability(voTimePlusExtra);
			}
			this.controlCountdown.start(onGo);
		}
	};

	p.lockControls = function(lock)
	{
		if (this.panel.seedContainer)
			this.panel.seedContainer.lockY = lock;
	};

	/**
	 * Start adding item to the stage
	 * @method startPlacingObjects
	 */
	p.startPlacingObjects = function()
	{
		if (_app.isTutorial)
		{
			if (DebugOptions.tutorial && DebugOptions.tutorial !== true)
			{
				this.tutorial.nextTask(DebugOptions.tutorial);
				DebugOptions.tutorial = true;
				this.lockControls(false);
			}
			else
			{
				this.tutorial.startFlyingTutorial();
			}
		}
		else
		{
			_powerupManager = new PowerupManager(_config);
			this.placeObjects = true;
			this.nextSegmentStart = this.panel.camera.viewport.right;
		}
	};

	/**
	 * The update function everyframe
	 * @method update
	 * @param {int} elapsed time in ms since the last frame udpate
	 */
	p.update = function(elapsed)
	{
		var panel = this.panel;
		var seedContainer = panel.seedContainer;
		var natureCat = panel.natureCat;
		var pixelDistance = panel.pixelDistance;

		var viewport = panel.camera.viewport;
		var viewportLeft = viewport.left;
		var viewportRight = viewport.right;

		// See if Nature Cat is now off screen
		// MAGIC: 700 = (naturecat.getBounds().x + naturecat.getBounds().width)
		if (natureCat.visible && natureCat.x + 700 < viewportLeft)
		{
			natureCat.visible = false;
			panel.breathMeter.visible = false;
			if (!_app.isTutorial && !DebugOptions.skipLaunch)
			{
				// Here's some Nature Cat VO lines about the launch power that we have
				// to play 'off screen' because we are not animating these line
				var vo = this.burstObject.bucket.vo;
				if (Array.isArray(vo))
				{
					vo = vo.random();
				}
				if (vo)
				{
					_app.voPlayer.play(vo);
				}
			}
		}

		// Update floaters addiational movement
		var floaters = panel.floaters;
		var floater = null;
		for (i = 0, len = floaters.length; i < len; ++i)
		{
			floater = floaters[i];
			floater.move(elapsed, pixelDistance, viewportLeft, viewportRight);
		}

		if (_app.isGameOver === false)
		{
			// Update seeds
			seedContainer.update(elapsed);
			// Update camera
			panel.camera.update();
		}

		// Update the tutorial if active
		if (_app.isTutorial)
		{
			this.tutorial.update(elapsed);
			return;
		}

		if (_app.isGameOver === false)
		{
			// How many pixels have we traveled in this run:
			_displayDistance = Math.floor(pixelDistance / _config.params.distanceFactor);
			panel.hud.distance = _displayDistance;

			var currDifficulty = this.currDifficulty;
			if (currDifficulty.distance > 0)
			{
				if (_displayDistance - currDifficulty.startingDistance > currDifficulty.distance)
				{
					this.setLevel(parseInt(currDifficulty.level) + 1);
				}
			}

			// Award the 500ft badge if they havn't gotten it already
			if (!_app.fiveHundredFeetCheck && _displayDistance >= FIVE_HUNDRED_FT)
			{
				app.container.send('badgeEvent', 'fiveHundredFeet');
			}
		}

		// Update Hal
		_app.hal.update(elapsed);

		if (this.placeObjects)
		{
			var powerupManager = _powerupManager;
			powerupManager.update(elapsed);
			if (viewportRight >= this.nextSegmentStart)
			{
				// If there is a powerup available, throw it in as a segment,
				// otherwise, get another random segment
				var levelSegment = powerupManager.getSegment(seedContainer.isHealthFull) ||
					_levelSegments.random();
				this.nextSegmentStart += levelSegment.length;
				this.spawnSegment(levelSegment);
			}
		}
	};

	p.onCollectPowerup = function(obj)
	{
		var panel = this.panel;
		var seedContainer = panel.seedContainer;
		var type = obj.type;
		var floater = obj.floater;
		var sfx = floater.powerupData.sfx;
		if (sfx)
		{
			_app.sound.play(sfx);
		}

		var indexOf = null;
		var floaters = panel.floaters;
		switch (type)
		{
			case Powerup.Hal:
				seedContainer.onCollectHal(floater);
				_app.hal.start();
				break;
			case Powerup.Shield:
				indexOf = floaters.indexOf(floater);
				seedContainer.onCollectShield(
					floaters.splice(indexOf, 1)[0],
					obj.seed);
				_powerupManager.startCountdown();
				break;
			case Powerup.Life:
				indexOf = floaters.indexOf(floater);
				seedContainer.onCollectLife(
					floaters.splice(indexOf, 1)[0],
					obj.seed);
				_powerupManager.startCountdown();
				break;
		}
	};

	/**
	 * Clear all the floading objects
	 * @method returnFloatersToPool
	 */
	p.returnFloatersToPool = function()
	{
		var panel = this.panel;
		var floaters = panel.floaters;
		var left = panel.camera.viewport.left;
		var worldContainer = panel.worldContainer;
		for (var i = floaters.length - 1; i >= 0; i--)
		{
			var floater = floaters[i];
			// Check if floater is in visible area
			if (floater.isActive(left) === false)
			{
				// Remove from the active array
				floaters.splice(i, 1);
				worldContainer.removeChild(floater);
				floater.reset();
				// User did not collect a powerup, start the countdown
				if (floater.isPowerupSegment && !floater.collected)
				{
					_powerupManager.startCountdown();
				}
				// If there is an array containing the type of floater, push the floater into that pool-array
				var pool = _app.floaterPools[floater.type];
				if (pool)
				{
					pool.push(floater);
				}
				// If that pool array doesn't exist, start a pool with this new item
				else
				{
					_app.floaterPools[floater.type] = [floater];
				}
			}
		}
	};

	/**
	 * Launch the segment
	 * @method spawnSegment
	 */
	p.spawnSegment = function(levelSegment)
	{
		// Check all previous floaters
		this.returnFloatersToPool();

		var panel = this.panel;
		var worldContainer = panel.worldContainer;
		var floaters = panel.floaters;
		var floatersDict = _config.floaters;
		var objects = levelSegment.objects;
		var nextSegmentStart = this.nextSegmentStart;
		for (var i = 0, len = objects.length; i < len; ++i)
		{
			var data = objects[i];

			var type = data.type;
			var objectPool = _app.floaterPools[type];
			if (!objectPool)
			{
				objectPool = [];
			}

			var floater;
			// ~szk: due to some factors I have yet to figure out, the frisbee does not recycle correctly, so I put a hook in here to make it always spawn a new item.
			if (objectPool.length && type != 'hal')
			{
				floater = objectPool.pop();
				floater.init(data);
			}
			else
			{
				if (type == 'life')
				{
					continue;
				}
				floater = new Floater(floatersDict[type], data, type);
				objectPool.push(floater);
			}

			// ~szk: The power up items are a single segment item so that they work with the current segment-floater placement system. However, rather than define them multiple times across files, these have one file, but an array of positions they could instantiate at. e.g. Hal's frisbee will always animate the same, but might come in at different y pos.
			if (data.positions && data.positions.length)
			{
				var pos = data.positions.random();
				data.x = pos.x;
				data.y = pos.y;
			}
			floater.x = nextSegmentStart + data.x;
			floater.y = data.y;

			worldContainer.addChildAt(floater, 0);
			floaters.push(floater);
			floater.start();
		}
	};

	/**
	 * Setter to pause the media
	 * @property {Boolean} pauseMedia
	 */
	Object.defineProperty(p, 'pauseMedia',
	{
		set: function(paused)
		{
			var sound = _app.sound;
			var animator = _app.animator;
			if (paused)
			{
				animator.pause();
				sound.pauseAll();
			}
			else
			{
				animator.resume();
				sound.resumeAll();
			}
			_app.pauseCalls(paused);

			if (this.controlCountdown)
			{
				this.controlCountdown.paused = paused;
				pauseChildren.call(this.controlCountdown, paused);
			}

			//~szk: Animator doesn't pause 'gotoAndPlay(0)' floaters, so I have to stop them manually
			var floaters = (this.panel ? this.panel.floaters : null) || [];
			for (i = 0, length = floaters.length; i < length; ++i)
			{
				var floater = floaters[i];
				var art = floater.art;
				if (art.gotoAndPlay)
				{
					if (paused)
					{
						art.stop();
					}
					else
					{
						art.play();
					}
					// prevent the bubble timeline from playing
					if (art.sparkleFX && paused === false)
					{
						art.stop();
						art.sparkleFX.play();
					}
					else
					{
						pauseChildren.call(art, paused);
					}
				}

				var sfx = floater.sfx;
				if (sfx)
				{
					if (paused)
					{
						sound.stop(sfx);
					}
					else
					{
						sound.play(sfx);
					}
				}
			}
		}
	});

	var pauseChildren = function(paused)
	{
		if (!this.children) return;
		for (var i = 0, len = this.children.length; i < len; i++)
		{
			var child = this.children[i];
			if (child.timeline)
			{
				if (paused)
					child.stop();
				else
					child.play();
			}
		}
	};

	/**
	 * Setter to pause the media
	 * @property {Boolean} pauseTween
	 */
	Object.defineProperty(p, 'pauseTween',
	{
		set: function(paused)
		{
			_app.off('update', Tween.tick);
			if (!paused)
			{
				_app.on('update', Tween.tick);
			}
		}
	});

	/**
	 * called from pause button in normal UI
	 * @property {Boolean} paused
	 */
	Object.defineProperty(p, 'paused',
	{
		set: function(paused)
		{
			this._paused = paused;
			var panel = this.panel;
			var pauseMenu = panel.pauseMenu;
			var seedContainer = panel.seedContainer;
			if (paused)
			{
				// pause the game
				this.pauseMedia = true;
				if (seedContainer)
				{
					seedContainer.enable = false;
				}
				_app.off('update', this.update);

				panel.addChild(pauseMenu);
				pauseMenu.show();
				pauseMenu.on('resume', this.togglePause);
				pauseMenu.on('restart', this.handlePauseRestart);
				pauseMenu.once('enter', this.onEnter);
			}
			else
			{
				// Enable the tweening
				this.pauseTween = false;
				if (seedContainer)
				{
					seedContainer.enable = true;
				}

				_app.on('update', this.update);

				pauseMenu.hide();
				pauseMenu.off('resume', this.togglePause);
				pauseMenu.off('restart', this.handlePauseRestart);
				pauseMenu.once('exit', this.onExit);

			}
		},
		get: function()
		{
			return this._paused;
		}
	});

	p.onEnter = function()
	{
		// Disable the tweening
		this.pauseTween = true;
	};

	p.onExit = function()
	{
		// resume the game
		this.pauseMedia = false;
	};

	/**
	 * Toggle the paused state of the game
	 * @method togglePause
	 */
	p.togglePause = function(ev)
	{
		this.paused = !this._paused;
		this.panel.hud.pauseButton.enabled = !this._paused;
	};

	/**
	 * Handle the restart button on the pause menu
	 * @method handlePauseRestart
	 */
	p.handlePauseRestart = function()
	{
		var panel = this.panel;
		var seedContainer = panel.seedContainer;
		var hud = panel.hud;

		seedContainer.off('moveOffHal', this.moveOffHal);
		seedContainer.off('lose', this.endGameplayPhase);
		seedContainer.off('startPlacingObjects', this.startPlacingObjects);
		seedContainer.enabled = false;

		hud.pauseButton.off('buttonPress', this.togglePause);
		hud.show(false);

		this.togglePause();
		this.restart();
	};

	/******************
		Score Phase
	*******************/

	p.startScorePhase = function()
	{
		var panel = this.panel;
		// textfield for distance/'you got a high score'
		var score = _displayDistance;
		// is THIS round the new high score?
		if (score > _app.userHighScore)
		{
			_app.userHighScore = score;
		}

		// Remove all elements from the screen
		var floaters = panel.floaters;
		for (var i = 0, len = floaters.length; i < len; i++)
		{
			var floater = floaters[i];
			var parent = floater.parent;
			Tween.get(floater).to(
			{
				alpha: 0
			}, 750).call(parent.removeChild.bind(parent, floater));
			if (floater.sfx)
			{
				_app.sound.fadeOut(floater.sfx, 1000, 0);
			}
		}

		// Setup and play the animation
		panel.hud.show(false);
		panel.scoreDisplay.show(score, _app.userHighScore);
		new DelayedCall(
			panel.scoreCharacters.show.bind(panel.scoreCharacters, score),
			1250);

		// Handle when the score state calls a restart
		panel.scoreDisplay.once('restart', this.restart);
	};

	/**
	 * Called from restart button listener
	 * @return {[type]} [description]
	 */
	p.restart = function()
	{
		_app.manager.refresh();
	};

	/**
	 * When the state starts exiting
	 * @method exitStart
	 */
	p.exitStart = function()
	{
		_app.hal.off('halStart', this.onHalStart);
		_app.off('resumed', this.onResumed);
		_app.off('update', this.update);
		this.panel.natureCat.off('startBlow', this.startGameplayPhase);
		this.panel.breathMeter.off('complete', this.launch);
		this.panel.hud.pauseButton.off('buttonPress', this.togglePause);
		this.panel.scoreDisplay.off('restart', this.restart);
		this.panel.pauseMenu.off('enter', this.onEnter);
		this.panel.pauseMenu.off('exit', this.onExit);
		if (this.panel.seedContainer)
		{
			this.panel.seedContainer.off('collectPowerup', this.onCollectPowerup);
			this.panel.seedContainer.off('lose', this.endGameplayPhase);
			this.panel.seedContainer.off('moveOffHal', this.moveOffHal);
			this.panel.seedContainer.off('startControlCountdown', this.startControlCountdown);
			this.panel.seedContainer.off('startPlacingObjects', this.startPlacingObjects);
		}

		var items = [
			this.panel.scoreCharacters
		];
		for (var i = 0; i < items.length; ++i)
		{
			var item = items[i];
			if (item && item.exitStart)
			{
				item.exitStart();
			}
		}
		var controlCountdown = this.controlCountdown;
		if (controlCountdown)
		{
			if (controlCountdown.parent)
				controlCountdown.parent.removeChild(controlCountdown);
			if (controlCountdown.destroy)
				controlCountdown.destroy();
			controlCountdown = null;
			this.controlCountdown = null;
		}
		DelayedCall.destroyCalls();
		_app.voPlayer.stop();
		_app.animator.stopAll();

		Tween.removeTweens(this.panel.seedContainer);

		this.sound.stopContext('vo');
		this.sound.stopContext('sfx');

		_app.skipIntro = true;
	};

	/**
	 * When the game is fully exited
	 * @method exit
	 */
	p.exit = function()
	{
		var i = 0;
		this.panel.teardown();

		// Possible destroyable assets
		var destroyables = [
			_levelSegments,
			_app.hal,
			this.scrollingBackground,
		];
		for (i = 0, len = destroyables.length; i < len; i++)
		{
			var d = destroyables[i];
			if (d)
			{
				Tween.removeTweens(d);
				if (d.destroy)
					d.destroy();
			}
		}
		destroyables = null;

		this.placeObjects = null;
		_levelSegments = null;
		_app.hal = null;
		DebugOptions.skipLaunch = null;

		s.exit.call(this);
	};

	namespace('nature').GameState = GameState;
}());